import { VariantData } from "../interface";
import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const updateVariantUrl = async (
  id: number,
  args: Partial<VariantData> & { user: any } 
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/products/variant/url/${id}`,
      { data: args } 
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to update variant");
  }
};
